/* VYROXE micro-animations — behaviour layer (added 2026-10-23).
   Tags commerce surfaces for scroll-reveal, fades images in on load,
   and gives the header a shadow once the page scrolls. No-ops entirely
   when the visitor prefers reduced motion. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header shadow on scroll */
  var onScroll = function () {
    document.body.classList.toggle('vx-scrolled', window.scrollY > 12);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (reduced) return;

  /* Image fade-in */
  var imgs = document.querySelectorAll('#MainContent img');
  imgs.forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) { img.classList.add('vx-img-in'); return; }
    img.classList.add('vx-img-wait');
    var done = function () { img.classList.add('vx-img-in'); img.classList.remove('vx-img-wait'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  });

  /* Scroll reveal */
  var SELECTORS = [
    '.card-wrapper', '.multicolumn-card', '.image-with-text__content',
    '.rich-text__wrapper', '.featured-collection .title-wrapper',
    '.collection-list .card-wrapper', '.blog__post', '.article-card',
    '.product__info-wrapper > *', '.related-products .title-wrapper',
    '.collapsible-content__wrapper', '.newsletter__wrapper'
  ].join(',');
  var targets = Array.prototype.slice.call(document.querySelectorAll(SELECTORS));
  if (!('IntersectionObserver' in window) || !targets.length) {
    targets.forEach(function (el) { el.classList.add('vx-in'); });
    return;
  }
  /* stagger: index among tagged siblings, capped */
  var seen = new Map();
  targets.forEach(function (el) {
    var parent = el.parentElement;
    var i = seen.get(parent) || 0;
    seen.set(parent, i + 1);
    el.style.setProperty('--vx-i', Math.min(i, 5));
    el.classList.add('vx-reveal');
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('vx-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  targets.forEach(function (el) { io.observe(el); });
})();

/* Hero off-screen pause: stop the 4K hero video decoding and hide the
   fixed particle canvas once the hero leaves the viewport. */
(function () {
  var hero = document.getElementById('vyroxe-hero');
  if (!hero || !('IntersectionObserver' in window)) return;
  var video = hero.querySelector('.hero-bg-video');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        document.documentElement.classList.remove('vx-hero-away');
        if (video && video.paused && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          var p = video.play(); if (p && p.catch) p.catch(function () {});
        }
      } else {
        document.documentElement.classList.add('vx-hero-away');
        if (video && !video.paused) video.pause();
      }
    });
  }, { threshold: 0.02 });
  io.observe(hero);
})();


/* All Products: default to newest-first on bare /collections/all visits.
   The built-in collection has no admin/API sort setting, so swap in the
   server-rendered newest-first grid section and pin the URL + sort select. */
(function () {
  var path = window.location.pathname.replace(/\/+$/, '');
  if (path !== '/collections/all') return;
  var params = new URLSearchParams(window.location.search);
  if (params.has('sort_by')) return;
  function run() {
    var q = new URLSearchParams(window.location.search);
    q.set('sort_by', 'created-descending');
    q.set('section_id', 'main-collection-product-grid');
    fetch('/collections/all?' + q.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[id^="shopify-section-"]');
        var current = document.querySelector('[id^="shopify-section-"][id$="__product-grid"]');
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
        document.querySelectorAll('select[name="sort_by"]').forEach(function (s) { s.value = 'created-descending'; });
        var clean = new URLSearchParams(window.location.search);
        clean.set('sort_by', 'created-descending');
        window.history.replaceState({}, '', window.location.pathname + '?' + clean.toString());
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
